import { defineComponent, reactive, watch } from '@vue/composition-api'
import './index.scss'
import _ from 'lodash'
import BarScore from '@/pages/Survey/components/BarScore'
import StarScore from '@/pages/Survey/components/StarScore'
import FaceScore from '@/pages/Survey/components/FaceScore'
const MatrixScaleContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item), //编辑数据源
      errorText: ''
    })

    watch(
      () => props.item,
      (val) => {
        state.editItem = _.cloneDeep(val)
      },
      {
        deep: true
      }
    )

    const updateValue = (value, index) => {
      state.editItem.matrixValue[index].value = value
      state.editItem.isShowTitleError = false
      emit('answer', state.editItem)
    }
    const getTrueValue = (matrixTopicsItem) => {
      let value: any = null
      props.item.matrixValue?.forEach((item) => {
        if (item.subTopicId === matrixTopicsItem.bizId) {
          value = item.value
        }
      })
      return value
    }
    return () => {
      return (
        <div class="matrix-nps-topic-content">
          <div class="matrix-nps-topic-content-right">
            <div class="matrix-nps-topic-content-right-item-title">
              <span>{props.item.topicSetting.minScoreDesc}</span>
              <span style={{ flex: 1 }}></span>
              <span>{props.item.topicSetting.maxScoreDesc}</span>
              {
                /* 根据后端条件判断要不要渲染 */
                !!props?.item?.topicSetting.customizeOption && (
                  <div class="cust-title">
                    {props?.item?.topicSetting.customizeOptionValue}
                  </div>
                )
              }
            </div>
            {props.item.matrixTopics.map((sitem, index) => {
              return (
                <div class="matrix-nps-topic-content-right-item">
                  <div
                    class="sub-title"
                    domPropsInnerHTML={sitem.topicName}></div>
                  {!props.item.topicSetting.scoreStyle && (
                    <div class="sub-score">
                      <BarScore
                        value={
                          Number(getTrueValue(sitem)) || getTrueValue(sitem)
                        }
                        minScoreDesc={props.item.topicSetting.minScoreDesc}
                        maxScoreDesc={props.item.topicSetting.maxScoreDesc}
                        onupdateValue={(value) => updateValue(value, index)}
                        maxScore={props.item.topicSetting.maxScore}
                        showTitle={false}
                        topicSetting={props.item.topicSetting}></BarScore>
                    </div>
                  )}
                  {props.item.topicSetting.scoreStyle === 1 && (
                    <div class="sub-score">
                      <StarScore
                        value={
                          Number(getTrueValue(sitem)) || getTrueValue(sitem)
                        }
                        minScoreDesc={props.item.topicSetting.minScoreDesc}
                        maxScoreDesc={props.item.topicSetting.maxScoreDesc}
                        onupdateValue={(value) => updateValue(value, index)}
                        maxScore={props.item.topicSetting.maxScore}
                        showTitle={false}
                        topicSetting={props.item.topicSetting}></StarScore>
                    </div>
                  )}
                  {props.item.topicSetting.scoreStyle === 2 && (
                    <div class="sub-score">
                      <FaceScore
                        value={
                          Number(getTrueValue(sitem)) || getTrueValue(sitem)
                        }
                        minScoreDesc={props.item.topicSetting.minScoreDesc}
                        maxScoreDesc={props.item.topicSetting.maxScoreDesc}
                        onupdateValue={(value) => updateValue(value, index)}
                        maxScore={props.item.topicSetting.maxScore}
                        showTitle={false}
                        topicSetting={props.item.topicSetting}></FaceScore>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )
    }
  }
})

export default MatrixScaleContent
